var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-layout',[_c('modify-table',{ref:"modifyTable",staticStyle:{"margin-top":"2px"},on:{"reset":_vm.reset,"selectRow":_vm.selectRow}}),_c('modify-detail',{ref:"modifyDetail",staticStyle:{"margin-top":"2px"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }